import { Injectable } from "@angular/core";
import { BaseApi } from "./baseService";
import { Http, RequestOptions } from "@angular/http";
import { ConfigService } from "./configService";
import { BaseResponse } from "../objects/common/baseResponse";
import { ClassificationRequest } from "../objects/zonos/classificationRequest";
import { LandedCostRequest } from "../objects/zonos/landedCostRequest";
import { ZonosRequest } from "../objects/zonos/zonosRequest";

@Injectable()
export class ZonosService extends BaseApi {
    constructor(http: Http, configService: ConfigService) {
        super(http, configService);
    }

    public classification(request: ZonosRequest): Promise<BaseResponse<any>> {
        return this.post(new RequestOptions({
            url: `product/classification`,
            body: request
        }))
    }

    public landedCost(request: LandedCostRequest): Promise<BaseResponse<any>> {
        return this.post(new RequestOptions({
            url: `product/landedcost`,
            body: request
        }))
    }
}



// WEBPACK FOOTER //
// ./app/services/zonos.service.ts